var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogout = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39832",
    "data-name": "Group 39832",
    transform: "translate(13801 -16032)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18,
    height: 18,
    transform: "translate(-13801 16032)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-13804 16030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34582",
    "data-name": "Group 34582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62802",
    "data-name": "Path 62802",
    d: "M15,18.048a.952.952,0,0,1-.952.952h-8.1A.952.952,0,0,1,5,18.048V3.952A.952.952,0,0,1,5.952,3h8.1A.952.952,0,0,1,15,3.952V8h1V3.952A1.955,1.955,0,0,0,14.048,2h-8.1A1.955,1.955,0,0,0,4,3.952v14.1A1.955,1.955,0,0,0,5.952,20h8.1A1.955,1.955,0,0,0,16,18.048V14H15Z",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62803",
    "data-name": "Path 62803",
    d: "M19.854,10.646l-2-2-.707.707L18.293,10.5H9v1h9.293l-1.146,1.146.707.707,2-2A.5.5,0,0,0,19.854,10.646Z",
    fill: "#95A1B2"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.5488a425.svg";
export { ForwardRef as ReactComponent };